export default __webpack_public_path__ + "static/1-d7fc09bf0b36a83562eb2c57c5c1e6c3.webp";